<template>
  <div>
    <Input @on-focus="openGroup = true" :value="name" readonly placeholder="请选择" :clearable="clearable"
      @on-clear='clear' :disabled='disabled'></Input>

    <Drawer :placement="placement" :closable="false" v-model="openGroup" draggable class="my-drawer">
      <groupTree @group="reGroup" @groups="reGroups" :isMore="more" :filterGroup='filterGroup' :sousuo='true'>
      </groupTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["placement", "clearable", "more", "disabled", "filterGroup"],
  data() {
    return {
      openGroup: false,
      name: ""
    };
  },
  methods: {
    reGroup(v) {
      if (!this.more) {
        this.openGroup = false;
        this.name = v.name;
        this.$emit("update:id", v.id);
        this.$emit("update:name", v.name);
        this.$emit("group", v);
      }

    },
    reGroups(v) {
      var ids = [], names = [];
      for (let i = 0; i < v.length; i++) {
        ids.push(v[i].id);
        names.push(v[i].name);
      }
      this.$emit('groupIds', ids);
      //this.$emit('groupNames', names);
      this.name = this.text(names);
    },
    text(t) {
      if (t.length == 1) {
        return t[0]
      } else {
        return '选择了' + t.length + "个"
      }
    },
    clear() {
      this.$emit("update:id", '');
      this.$emit("update:name", '');
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/common/selectGroup.vue